import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col, Modal, Button, Switch, Space, Radio, Slider } from "antd";
import ControllerPicture from "../picture/controller";

import { getcontroller, setshowCtlStored } from "../../stored/mydata";

export default function Erv(props) {
  const dispatch = useDispatch();

  const dataController = useSelector(getcontroller);
  const [dataDevice, setDataDevice] = useState(props.data);

  useEffect(() => {}, [dataDevice]);

  useEffect(() => {
    if (dataDevice["mac"] === dataController["mac"]) {
      setDataDevice({
        ...dataDevice,
        device_temp:
          dataController["temp"] === "error" ? "" : dataController["temp"],
        device_mode: dataController["mode"],
        device_fanspeed: dataController["speed"],
        device_status: dataController["status"],
        device_sweep: dataController["sweep"],
      });
      // dataDevice["device_temp"] = dataController["temp"] === "error" ? "" : dataController["temp"];
      // dataDevice["device_mode"] = dataController["mode"];
      // dataDevice["device_fanspeed"] = dataController["speed"];
      // dataDevice["device_status"] = dataController["status"];
      // dataDevice["device_sweep"] = dataController["sweep"];
    }
  }, [dataController]);

  // const marks = {
  //   0: (
  //     <>
  //       <div style={styles.textModeFan}>Low</div>
  //     </>
  //   ),
  //   50: (
  //     <>
  //       <div style={styles.textModeFan}>Mid</div>
  //     </>
  //   ),
  //   100: (
  //     <>
  //       <div style={styles.textModeFan}>High</div>
  //     </>
  //   ),
  // };

  const marksBtnFan = [
    {
      value: 0,
      nameBtn: "Low",
    },
    {
      value: 50,
      nameBtn: "Mid",
    },
    {
      value: 100,
      nameBtn: "High",
    },
  ];

  const fanspeed = (value) => {
    if (value === "Low") {
      return 0;
    } else if (value === "Mid") {
      // quiet แบบเงียบ
      return 50;
    } else if (value === "High") {
      return 100;
    } else {
      return 0;
    }
  };

  return (
    <div>
      <div style={styles.card}>
        <Row>
          <Col span={3} style={{ width: "200px" }}>
            {ControllerPicture.doas()}
          </Col>
          <Col span={21}>
            {/* <div style={styles.fontInpage}>Dedicated Outdoor Air System</div> */}
            <div style={styles.fontInpage}>DOAS</div>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col span={4} style={styles.textMode}>
            Mode:
          </Col>
          <Col span={20}>
            <Radio.Group
              onChange={(e) => {
                // console.log(e.target.value);
              }}
              // value={1}
              value={props.data["mode"] === "auto" ? 1 : 2}
            >
              <Row>
                <Col span={12}>
                  <Radio
                    value={1}
                    style={
                      props.data["mode"] === "auto"
                        ? styles.fontNumber_choose
                        : styles.fontNumber
                    }
                  >
                    Auto
                  </Radio>
                </Col>
                <Col span={12}>
                  <Radio
                    value={2}
                    style={
                      props.data["mode"] === "auto"
                        ? styles.fontNumber
                        : styles.fontNumber_choose
                    }
                  >
                    Manual
                  </Radio>
                </Col>
              </Row>
            </Radio.Group>
          </Col>
        </Row>
        <div>
          <Row>
            <Col span={8} style={{ width: "250px", textAlign: "end" }}>
              {ControllerPicture.minus()}
            </Col>
            <Col span={8} style={styles.fontNumberTemp}>
              {props.data["temp"]}°
            </Col>
            <Col span={8} style={{ width: "250px" }}>
              {ControllerPicture.plus()}
            </Col>
          </Row>
        </div>

        {/* Start Mode Fan */}
        <Row>
          <Col span={5}>
            <Row>
              <Col span={12} style={{ width: "200px" }}>
                {ControllerPicture.wind()}
              </Col>
              <Col span={12}>
                <div style={styles.fontInpage}>Fan</div>
              </Col>
            </Row>
          </Col>
        </Row>
        {/* {dataDevice["device_status"] === "on" ? ( */}
        <div style={styles.cardInerv}>
          <div>
            <Row gutter={[16, 16]} justify="center" align="middle">
              {marksBtnFan.map((item) => (
                <Col key={item.value} span={6}>
                  <div
                    style={
                      item.value === fanspeed(dataDevice["device_fanspeed"])
                        ? styles.btnFanChoose
                        : styles.btnFan
                    }
                    // onClick={() => controllerSpeed(item.value)}
                  >
                    {item.nameBtn}
                  </div>
                </Col>
              ))}
            </Row>
          </div>
        </div>

        {/* ) : ( */}
        {/* <></> */}
        {/* )} */}
        {/* End Mode Fan */}

        {/* <div style={styles.cardInerv}>
          <Row>
            <Col span={7}>
              <Row>
                <Col span={12} style={{ width: "250px" }}>
                  {ControllerPicture.wind()}
                </Col>
                <Col span={12}>
                  <div style={styles.fontInpage}>Fan</div>
                </Col>
              </Row>
            </Col>
            <Col span={17}>
              <Slider
                marks={marks}
                defaultValue={50}
                step={50}
                //   activeDotStyle={{
                //     backgroundColor: "rgba(62, 168, 184, 1)"
                //   }}
                tooltip={{
                  formatter: null,
                }}
              />
            </Col>
          </Row>
        </div> */}
      </div>
    </div>
  );
}

const styles = {
  head: {
    backgroundColor: "#F0F9FB",
    height: "108px",
  },
  card: {
    display: "flex",
    padding: "16px",
    flexDirection: "column",
    // alignItems: "flex-start",
    gap: "12px",
    borderRadius: "16px",
    border: "1px solid #B5EAEF",
  },
  cardInerv: {
    flexShrink: "0",
    borderRadius: "16px",
    border: "1px solid #B5EAEF",
    background: "#FBFBFB",
    padding: "10px 15px 10px 8px",
  },
  // fontInpage: {
  //   color: "#3EA8B8",
  //   // textAlign: "center",
  //   paddingTop: "2px",
  //   fontFeatureSettings: "clig off, liga off",
  //   fontSize: "14px",
  //   fontStyle: "normal",
  //   fontWeight: "500",
  //   lineHeight: "21px",
  // },
  fontInpage: {
    color: "#56585D",
    paddingTop: "2px",
    fontFeatureSettings: "clig off, liga off",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: "500",
    lineHeight: "21px",
  },
  fontNumberTemp: {
    color: "#56585D",
    textAlign: "center",
    fontFamily: "Gotham",
    fontSize: "36px",
    fontStyle: "normal",
    fontWeight: "300",
    lineHeight: "32px",
    letterSpacing: "0.15px",
    marginTop: "10px",
  },
  fontNumber_choose: {
    color: "#56585D",
    textAlign: "center",
    fontFamily: "Gotham",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: "500",
    lineHeight: "21px",
  },
  fontNumber: {
    color: "#919499",
    textAlign: "center",
    fontFamily: "Gotham",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: "500",
    lineHeight: "21px",
  },
  textMode: {
    color: "#56585D",
    // textAlign: "center",
    fontFamily: "Gotham",
    fontFeatureSettings: "clig off, liga off",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "21px" /* 175% */,
  },
  textModeFan: {
    color: "#56585D",
    // textAlign: "center",
    marginTop: "10px",
    fontFamily: "Gotham",
    fontFeatureSettings: "clig off, liga off",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "21px",
  },
  btnFan: {
    display: "flex",
    width: "30px" /* ปรับให้ปุ่มใหญ่ขึ้น */,
    height: "25px",
    padding: "10px",
    justifyContent: "center",
    alignItems: "center",
    flexShrink: "0",
    borderRadius: "14px",
    border: "1px solid #E3E3E3",
    background: "#FBFBFB",
    boxShadow: "0px 1px 1px 0px rgba(0, 0, 0, 0.10)",
    margin: "auto" /* จัดปุ่มให้อยู่กึ่งกลาง Col */,
    cursor: "pointer" /* ทำให้เป็น Cursor แบบคลิกได้ */,
  },
  btnFanChoose: {
    display: "flex",
    width: "30px",
    height: "25px",
    padding: "10px",
    justifyContent: "center",
    alignItems: "center",
    flexShrink: "0",
    borderRadius: "14px",
    border: "1px solid #B5EAEF",
    background: "#EBF4FA",
    boxShadow: "0px 1px 1px 0px rgba(0, 0, 0, 0.10)",
    fontWeight: "bold",
    margin: "auto" /* จัดปุ่มให้อยู่กึ่งกลาง Col */,
    cursor: "pointer" /* ทำให้เป็น Cursor แบบคลิกได้ */,
  },
  btnFanOff: {
    display: "flex",
    width: "30px" /* ปรับให้ปุ่มใหญ่ขึ้น */,
    height: "25px",
    padding: "10px",
    justifyContent: "center",
    alignItems: "center",
    flexShrink: "0",
    borderRadius: "14px",
    border: "1px solid #E3E3E3",
    background: "#FBFBFB",
    boxShadow: "0px 1px 1px 0px rgba(0, 0, 0, 0.10)",
    margin: "auto" /* จัดปุ่มให้อยู่กึ่งกลาง Col */,
    cursor: "pointer" /* ทำให้เป็น Cursor แบบคลิกได้ */,
  },
  btnFanChooseOff: {
    display: "flex",
    width: "30px",
    height: "25px",
    padding: "10px",
    justifyContent: "center",
    alignItems: "center",
    flexShrink: "0",
    borderRadius: "14px",
    border: "1px solid #E3E3E3",
    background: "#E3E3E3",
    boxShadow: "0px 1px 1px 0px rgba(0, 0, 0, 0.10)",
    fontWeight: "bold",
    margin: "auto" /* จัดปุ่มให้อยู่กึ่งกลาง Col */,
    cursor: "pointer" /* ทำให้เป็น Cursor แบบคลิกได้ */,
  },
};
